import { motion } from "framer-motion";
import { ArrowUpRight, Globe } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];
const BRANDS = ["/brands/kentucky.png", "/brands/dyon.png", "/brands/velari.png", "/brands/grooming.png"];

const Tile = ({ className = "", children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.6, delay, ease }}
    className={`group relative overflow-hidden rounded-[20px] border border-[#08083a]/10 shadow-[0_10px_30px_rgba(8,8,64,0.07)] transition-all duration-300 hover:shadow-[0_22px_50px_rgba(8,8,64,0.14)] ${className}`}>
    {children}
  </motion.div>
);

// CONCEPT 3 — "Modern Atelier": editorial bento grid, structured luxury, micro-interactions.
export const Concept3 = () => (
  <div className="bg-[#FFFAF4] text-[#08083a]">
    <div className="container-site py-14 lg:py-20">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#FE7D01]">Official Kentucky Horsewear Reseller</p>
          <h1 className="mt-3 font-display text-5xl leading-[1.0] sm:text-6xl">The atelier of equestrian.</h1>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-[#08083a]/65">
          Express worldwide shipping from our Ireland &amp; EU warehouses. Free over €100 in Ireland.
        </p>
      </div>

      <div className="grid auto-rows-[190px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {/* hero lifestyle */}
        <Tile className="sm:col-span-2 sm:row-span-2">
          <img src="/kentucky/life5.jpg" alt="Kentucky rider" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08083a]/80 via-[#08083a]/10 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-7 text-white">
            <p className="text-[11px] uppercase tracking-[0.22em] text-white/75">The Collection</p>
            <h2 className="mt-1.5 font-display text-3xl leading-tight sm:text-4xl">Rugs, tack &amp; rider apparel</h2>
            <a href="#" className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[#FE7D01] px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 group-hover:translate-x-0.5">
              Explore <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </Tile>

        {/* saffron statement */}
        <Tile className="sm:col-span-2 bg-[#FE7D01] text-white" delay={0.05}>
          <div className="flex h-full flex-col justify-between p-7">
            <Globe className="h-7 w-7" />
            <div>
              <p className="font-display text-3xl leading-tight sm:text-4xl">Shipped worldwide</p>
              <p className="mt-1 text-sm text-white/85">Express delivery to riders across the globe.</p>
            </div>
          </div>
        </Tile>

        {/* saddle pads */}
        <Tile delay={0.1}>
          <img src="/kentucky/life1.jpg" alt="Saddle pads" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08083a]/70 to-transparent" />
          <span className="absolute bottom-4 left-4 font-display text-xl text-white">Saddle Pads</span>
          <ArrowUpRight className="absolute right-4 top-4 h-5 w-5 text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
        </Tile>

        {/* grooming */}
        <Tile delay={0.15}>
          <img src="/kentucky/life2.jpg" alt="Grooming" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08083a]/70 to-transparent" />
          <span className="absolute bottom-4 left-4 font-display text-xl text-white">Grooming</span>
          <ArrowUpRight className="absolute right-4 top-4 h-5 w-5 text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
        </Tile>

        {/* warehouses (ink) */}
        <Tile className="sm:col-span-2 bg-[#08083a] text-white" delay={0.1}>
          <div className="flex h-full flex-col justify-between p-7">
            <div className="flex items-center gap-2 text-[#FE7D01]"><Globe className="h-5 w-5" /><span className="text-xs font-semibold uppercase tracking-[0.18em]">Logistics</span></div>
            <div>
              <p className="font-display text-2xl sm:text-3xl">Ireland &amp; EU warehouses</p>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.18em] text-white/55">IE · EU · WORLDWIDE — IN STOCK</p>
            </div>
          </div>
        </Tile>

        {/* brands */}
        <Tile className="sm:col-span-2 bg-white" delay={0.15}>
          <div className="flex h-full flex-col p-7">
            <p className="text-[11px] uppercase tracking-[0.22em] text-[#08083a]/50">Our Maisons</p>
            <div className="mt-auto grid grid-cols-4 items-center gap-4">
              {BRANDS.map((b) => (
                <img key={b} src={b} alt="" className="h-7 w-full object-contain opacity-60 transition-opacity duration-200 hover:opacity-100" />
              ))}
            </div>
          </div>
        </Tile>
      </div>
    </div>
  </div>
);
